import HelpPanel from '@cloudscape-design/components/help-panel'
import { useHelpPanelStore } from '@/state/helpPanelStore'

export default function HelpPanelComponent() {
  const { content } = useHelpPanelStore()

  return (
    <HelpPanel header={content?.header} footer={content?.footer}>
      {content?.body}
    </HelpPanel>
  )
}
